import { render, staticRenderFns } from "./Gundem.vue?vue&type=template&id=28f3f8d4&scoped=true"
import script from "./Gundem.vue?vue&type=script&lang=js"
export * from "./Gundem.vue?vue&type=script&lang=js"
import style0 from "./Gundem.vue?vue&type=style&index=0&id=28f3f8d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f3f8d4",
  null
  
)

export default component.exports